module.exports = __webpack_public_path__ + "img/Romatikken_skogtjern.9b24a643.jpg";